<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <ng-container *ngIf="referral && !loadingReferral">


    <div fxFlex="50">
      <button class="mr-2" mat-raised-button color="basic" (click)="returnBack()">Back</button>


    </div>
    <div fxFlex="50" style="text-align: right">

    </div>


  </ng-container>
</div>

<div class="content-card" fxLayout="row wrap" fxLayoutGap="10px">

  <!-- #region order details -->




  <mat-card class="container-md" style="min-width: 400px">
    <mat-progress-bar mode="indeterminate" *ngIf="loadingReferral" class="progress-bar"></mat-progress-bar>
    <mat-card-header fxLayout="row" fxLayoutGap="10px">
      <mat-card-title>
        <h5>🎁 Referral {{referral?.id}}</h5>
      </mat-card-title>
      <div fxFlex></div>
      <div>

        <!--
        <span *ngIf="false && order && order.webIdTransaction" style="margin-right: 10px;">
          <button mat-raised-button class="mr-1" color="blue" [disabled]="isResendWebidDisabled() && (order.webIdTransaction.status === 1)" (click)="resendWebIdLink(order)">Resend WebID</button>
        </span>-->


      </div>
    </mat-card-header>
    <mat-card-content class="mt-2">

      <span class="mr-2" *ngIf="!referral && !loadingReferral">Referral not exist/or has been removed</span>
      <span class="mr-2" *ngIf="loadingReferral">Loading data...</span>
      <div *ngIf="referral">


        <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
          <app-content-row [field]="field" [entity]="referral"></app-content-row>
        </div>

      </div>
    </mat-card-content>
    <mat-card-actions align="end" class="mt-2">

    </mat-card-actions>
  </mat-card>

  <div fxFlex="50">

    <div style="margin-top: 10px; margin-left: 10px; margin-bottom: 10px;" *ngIf="referrer">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>📯 Referrer: {{ referrer?.firstName }} {{ referrer?.lastName }}</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCustomer ">
          <app-content-row [field]="field" [entity]="referrer"></app-content-row>
        </div>

        <div *ngFor="let card of referrerCards">
          <div style="margin: 10px; font-weight: bold;">
            Card {{card.token}}
          </div>
          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCard ">
            <app-content-row [field]="field" [entity]="card"></app-content-row>
          </div>
        </div>

      </mat-expansion-panel>
    </div>


    <div style="margin-left: 10px; margin-bottom: 10px;" *ngIf="referee">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>📩 Referee: {{ referee?.firstName }} {{ referee?.lastName }}</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCustomer ">
          <app-content-row [field]="field" [entity]="referee"></app-content-row>
        </div>


        <div *ngFor="let card of refereeCards">
          <div style="margin: 10px; font-weight: bold;">
          Card {{card.token}}
          </div>
          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCard ">
            <app-content-row [field]="field" [entity]="card"></app-content-row>
          </div>
        </div>



      </mat-expansion-panel>
    </div>



    <div style="margin-left: 10px;" *ngIf="referral?.status == referralStatus.pendingBonus">
      <mat-card>

        <div style="margin-top: 10px; margin-bottom: 10px;">
          <b>Bonus payout</b>
        </div>


        <mat-card-content>
          <button mat-raised-button color="primary" [disabled]="isPayingBonus" (click)="payoutBonus()" >
            Pay out {{ referral.dueCommission }}
          </button>


        </mat-card-content>


      </mat-card>
    </div>

    <div style="margin-left: 10px;" *ngIf="referral?.status == referralStatus.completed">
      <mat-card>

        <div style="margin-top: 10px; margin-bottom: 10px;">
          <b>Bonus was paid</b>
        </div>


        <mat-card-content>
          The bonus was paid to the referrer.
        </mat-card-content>


      </mat-card>
    </div>



  </div>

</div>
